// ===================================================================
// Youtube埋め込み（自動再生なし）※フッター（wp_footer で出力）に置く
// ===================================================================
(function () {
  // ここを変えるだけで全体方針を切替可能
  const DEFAULTS = {
    autoplay: "0",   // 自動再生なし
    mute: "0"        // 自動再生しないのでミュートも不要
  };

  function buildSrc(videoId, opts = {}) {
    const base = "https://www.youtube.com/embed/" + encodeURIComponent(videoId);
    const autoplay = (opts.autoplay ?? DEFAULTS.autoplay);
    const mute     = (opts.mute ?? DEFAULTS.mute);

    // 最小＆安定
    const qs = [
      "controls=0",        // コントロール非表示
      "modestbranding=1",  // ロゴ抑制
      "playsinline=1",     // iOSインライン
      "rel=0",             // 同一チャンネル関連のみ
      "autoplay=" + autoplay,
      "mute=" + mute
    ].join("&");

    return base + "?" + qs;
  }

  function attachObserver(iframe) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const isVisible = entry.isIntersecting;
        const loaded = iframe.dataset.loaded === "1";
        const vid = iframe.dataset.videoId;

        if (isVisible && !loaded && vid) {
          const opts = {
            autoplay: iframe.dataset.autoplay, // 例: data-autoplay="1"
            mute: iframe.dataset.mute          // 例: data-mute="1"
          };
          iframe.src = buildSrc(vid, opts);
          iframe.dataset.loaded = "1";
        }

        // 画面外で止めたいなら下記を有効化（戻ると先頭から）
        // else if (!isVisible && loaded) {
        //   iframe.src = "";
        //   iframe.dataset.loaded = "0";
        // }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -10% 0px" });

    io.observe(iframe);
  }

  function init() {
    document.querySelectorAll(".js-yt-lazy").forEach(attachObserver);

    // 初期表示で既に見えているケース & bfcache 復帰
    const checkNow = () => {
      document.querySelectorAll(".js-yt-lazy").forEach(el => {
        if (el.dataset.loaded === "1" || !el.dataset.videoId) return;
        const r = el.getBoundingClientRect();
        const vh = innerHeight || document.documentElement.clientHeight;
        const vw = innerWidth  || document.documentElement.clientWidth;
        const vx = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
        const vy = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
        const ratio = (r.width && r.height) ? (vx * vy) / (r.width * r.height) : 0;
        if (ratio >= 0.1) {
          const opts = { autoplay: el.dataset.autoplay, mute: el.dataset.mute };
          el.src = buildSrc(el.dataset.videoId, opts);
          el.dataset.loaded = "1";
        }
      });
    };
    window.addEventListener("pageshow", checkNow);
    checkNow();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
